import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-insights-panel',
  templateUrl: './insights-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsPanelComponent {}
